import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Key } from '../key.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class KeysResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient) {}

  get(key_id: number, params?: QueryParams): Observable<Key> {
    return this.http.get<Key>(`${this.apiRoot}/user/keys/${key_id}`, { params });
  }

  save(body: Partial<Key>, params?: QueryParams): Observable<Key> {
    return this.http.post<Key>(`${this.apiRoot}/user/keys`, body, { params });
  }

  update(key_id: number, body: Key, params?: QueryParams): Observable<Key> {
    return this.http.put<Key>(`${this.apiRoot}/user/keys/${key_id}`, body, { params });
  }

  remove(key_id: number, params?: QueryParams): Observable<any> {
    return this.http.delete<Key>(`${this.apiRoot}/user/keys/${key_id}`, { params });
  }

  query(params?: QueryParams): Observable<Key[]> {
    return this.http.get<Key[]>(`${this.apiRoot}/user/keys`, { params });
  }

  search(params?: QueryParams): Observable<Key[]> {
    return this.http.get<Key[]>(`${this.apiRoot}/user/keys/search`, { params });
  }
}
